/**
 * Ambiente que muestra la pastilla de la barra superior.
 *
 * Se resuelve en RUNTIME y no en build: la imagen Docker es una sola para
 * test y prod (el `Dockerfile` fija `VITE_ENVIRONMENT=production` al
 * buildear), así que leer `import.meta.env` hacía que test dijera "Prod".
 * Prioridad: lo que inyecte el entrypoint del contenedor en `__CONFIG__`,
 * si no el host (los de test llevan `-test`), si no el valor de build (dev
 * local con `npm run dev`).
 */
export type Ambiente = 'local' | 'test' | 'prod';

/** `testing`, `TEST`, `production`, `development`… → uno de los tres. */
function normalizarAmbiente(valor: string): Ambiente {
  const v = valor.toLowerCase();
  if (v.startsWith('prod')) return 'prod';
  if (v.startsWith('test')) return 'test';
  return 'local';
}

export function detectarAmbiente(
  hostname: string,
  config: string | undefined = window.__CONFIG__?.VITE_ENVIRONMENT,
): Ambiente {
  // El manifest de test inyecta "testing" (visto en el deploy del 01/10):
  // no se compara contra valores exactos, se normaliza.
  if (config) return normalizarAmbiente(config);
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'local';
  if (/-test\.|^test\./.test(hostname)) return 'test';
  if (hostname.endsWith('.medicus.com.ar')) return 'prod';
  return normalizarAmbiente(import.meta.env.VITE_ENVIRONMENT ?? 'local');
}

const CLAVE_SIDEBAR = 'cargamasiva.sidebar-colapsado';

/**
 * Si el menú lateral quedó colapsado la última vez. Es una comodidad por
 * navegador (no viaja al server), así que vive en localStorage; si el
 * navegador no lo permite (ventana privada, datos bloqueados) arranca abierto.
 */
export function leerSidebarColapsado(): boolean {
  try {
    return localStorage.getItem(CLAVE_SIDEBAR) === '1';
  } catch {
    return false;
  }
}

export function guardarSidebarColapsado(colapsado: boolean): void {
  try {
    localStorage.setItem(CLAVE_SIDEBAR, colapsado ? '1' : '0');
  } catch {
    // Sin storage se pierde la preferencia al recargar; nada más.
  }
}
